import { useHowActiveReferralModal } from '../model/useHowActiveReferralModal';
import s from './how-active-referral.module.scss'
import { Modal } from '@shared/ui/modal/modal'

export const HowActiveReferralModal = () => {

  const { isOpen, close } = useHowActiveReferralModal()

  return (
		<Modal {...{isOpen, close}}>
        <div className={s.wrapper}>
            <div className={s.headInfo}>
                <h1>Как считается активный пользователь?</h1>
            </div>
            <div className={s.mainInfo}>
                <div className={s.info}> 
                    <span>
											Чтобы реферал начал учитываться в вашей реферальной системе, он должен провести не менее 3 платных занятий за последние 2 месяца.
										</span>
											
                    <span>
											Это же условие используется для поддержания вашего уровня: каждый день система автоматически пересчитывает количество активных рефералов.
										</span>
											
                    <span>
											Если реферал продолжает проводить не менее 3 платных занятий за последние 2 месяца, он остаётся активным. Если занятий становится меньше, он перестаёт учитываться при расчёте вашего уровня.
										</span>
                </div>
            </div>
        </div>
		</Modal>
  );
};